import { Controller } from "@hotwired/stimulus"

// On mobile: the share button fires the native OS share sheet (hides the dropdown).
// On desktop: the dropdown is shown by Bootstrap, with social network links
// and a "Copy link" button handled by this controller.
export default class extends Controller {
  static values = { url: String, title: String, text: String }
  static targets = ["btn", "menu"]

  get isMobile() {
    return navigator.share &&
      window.matchMedia("(max-width: 768px)").matches &&
      navigator.maxTouchPoints > 0
  }

  // Called on button click. On mobile, intercept and use native share sheet.
  // On desktop (incl. macOS where navigator.share now exists), let Bootstrap
  // open the dropdown instead.
  async open(event) {
    if (!this.isMobile) return // desktop: let Bootstrap dropdown open normally

    event.preventDefault()
    event.stopPropagation()

    try {
      await navigator.share({
        title: this.titleValue,
        text:  this.textValue,
        url:   this.urlValue || window.location.href,
      })
    } catch (e) {
      // User cancelled — not an error
    }
  }

  async copy(event) {
    event.preventDefault()
    const url = this.urlValue || window.location.href
    await navigator.clipboard.writeText(url)

    if (this.hasBtnTarget) {
      const btn = this.btnTarget
      const original = btn.innerHTML
      const label = btn.dataset.copiedLabel || "✓ Copied"
      btn.innerHTML = `${label}`
      setTimeout(() => { btn.innerHTML = original }, 2000)
    }

    // Close the dropdown
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove("show")
    }
  }
}
